import {Component, input, model, OnInit, output} from '@angular/core';
import {TrackableEntity} from "../../model/trackable-entity.model";
import {TemplateActionService} from "../../service/template-action.service";
import {TemplateDTO} from "../../common/model/template-dto.model";
import {EventActionService} from "../../service/event-action.service";
import {EventDTO} from "../../model/event.model";
import {PlaceActionService} from "../../service/place-action.service";
import {Place} from "../../model/place.model";

@Component({
  selector: 'app-trackable-items',
  templateUrl: './trackable-items.component.html',
  styleUrls: ['./trackable-items.component.scss']
})
export class TrackableItemsComponent implements OnInit {

  favoriteView = input<'standard' | 'fab-button'>('standard');
  size = input<'small' | 'medium'>('small');
  type = input<'event' | 'template' | 'place' | 'default'>('default');
  entity = model<TrackableEntity>();
  changeFavorite = output<TrackableEntity>();

  constructor(private templateActionService: TemplateActionService,
              private placeActionSvc: PlaceActionService,
              private eventActionService: EventActionService) {
  }

  ngOnInit() {
  }

  onToggle() {

    switch (this.type()) {
      case 'template':
        this.templateActionService.toggleFavorite(this.entity() as TemplateDTO).subscribe();
        break;
      case 'event':
        this.eventActionService.toggleFavorite(this.entity() as EventDTO).subscribe();
        break;
      case 'place':
        this.placeActionSvc.toggleFavorite(this.entity() as Place<any>).subscribe();
        break;
      default:
        throw new Error('Unknown trackable entity');
        break;

    }

    this.changeFavorite.emit(this.entity());
  }
}
